<template>
    <div>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="adType" label="广告类型:">
                    <el-radio-group v-model="formData.adType" @change="adTypeChange">
                        <el-radio :label="1">文案</el-radio>
                        <el-radio :label="2">图片</el-radio>
                        <el-radio :label="3">文字弹窗</el-radio>
                        <el-radio :label="4">图片弹窗</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="time1" label="展示时间:" :rules="[{ required: true, message: '请设置展示时间' }]">
                    <span slot="label">展示时间：<small><span class="el-icon-warning"></span> 到期后会被自动隐藏</small></span>
                    <el-date-picker v-model="formData.time1" type="datetimerange" range-separator="至"
                        value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="开始时间" end-placeholder="结束时间" unlink-panels>
                    </el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="bindIds" label="绑定对象:"
                    :rules="[{ validator: validateBindIds, required: true }]">
                    <span slot="label">
                        绑定对象：
                        <el-checkbox v-model="formData.isBind"
                            @change="formData.isBind ? '' : formData.bindIds = ''" :true-label="0" :false-label="1">
                            不限制ID</el-checkbox>
                    </span>
                    <el-input placeholder="请填写对象ID" v-model="formData.bindIds" maxlength="200"
                        :disabled="!formData.isBind ? true : false">
                    </el-input>
                    <small class="MT10 color-danger">
                        对象ID根据所选广告位，需要填写演出ID/众筹ID/周边ID，多个ID用逗号分隔。如果不限ID请勾选复选框
                    </small>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="link" label="跳转链接:">
                    <el-input placeholder="请填写跳转链接" v-model="formData.link" maxlength="200"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="aliLink" label="支付宝小程序跳转地址:">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8">
                            <el-input placeholder="支付宝小程序APPID" v-model="formData.aliLinkAppid" maxlength="50"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="16">
                            <el-input placeholder="支付宝小程序跳转路径" v-model="formData.aliLink" maxlength="200"></el-input>
                        </el-col>
                    </el-row>
                    <small class="MT10 color-danger">
                        注意：跳转到外部小程序，这里填写好信息以后，可能还需要对方小程序添加白名单，请联系对方小程序负责人
                    </small>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="wxLink" label="微信小程序跳转地址:">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8">
                            <el-input placeholder="微信小程序APPID" v-model="formData.wxLinkAppid" maxlength="50"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="16">
                            <el-input placeholder="微信小程序跳转路径" v-model="formData.wxLink" maxlength="200"></el-input>
                        </el-col>
                    </el-row>
                    <small class="MT10 color-danger">
                        注意：跳转到外部小程序，这里填写好信息以后，可能还需要对方小程序添加白名单，请联系对方小程序负责人
                    </small>
                </el-form-item>
            </el-col>
        </el-row>
        <template v-if="formData.adType == 1 || formData.adType == 2">
            <el-row v-if="formData.adType == 1" :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="title" label="展示标题:" :rules="[{ required: true, message: '请填写展示标题' }]">
                        <el-input placeholder="请填写展示标题" v-model.trim="formData.title" maxlength="40" show-word-limit>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="content" label="内容说明:">
                        <el-input type="textarea" placeholder="请填写内容说明" v-model="formData.content" :rows="4" maxlength="1000"
                            show-word-limit></el-input>
                        <!-- <tinymce v-model="formData.content" :height="200" :toolbar="['']" :menubar="false" v-if="reFresh"  style="width: 50%;"></tinymce> -->
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-else-if="formData.adType == 2" :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="imgPath" label="图片:" :rules="[{ required: true, message: '请上传图片' }]">
                        <image-upload :url.sync="formData.imgPath" :urlFull.sync="formData.imgPath"
                            accept="image/png, image/jpeg, image/jpg, image/gif, image/svga"  :width="1080"
                            :height="180"></image-upload>
                    </el-form-item>
                </el-col>
            </el-row>
        </template>
        <template v-else>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="showFrequency" label="弹窗打开频率:">
                        <el-select v-model="formData.showFrequency">
                            <el-option :value="1" label="首次进入时展示"></el-option>
                            <el-option :value="2" label="每日展示一次"></el-option>
                            <el-option :value="3" label="每次打开页面展示"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="closeCountDown" label="点击关闭按钮需要秒数:">
                        <span slot="label">
                            点击关闭按钮需要秒数（0-60秒）：
                            <el-checkbox v-if="formData.adType == 3" v-model="formData.isShowButton" :true-label="1" :false-label="0">显示关闭按钮
                            </el-checkbox>
                        </span>
                        <el-input-number style="width:100%" v-model="formData.closeCountDown" :min="0" :max="60"
                            :precision="0"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <template v-if="formData.adType == 3">
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="title" label="弹窗标题:" :rules="[{ required: true, message: '请填写弹窗标题' }]">
                            <el-input placeholder="请填写弹窗标题" v-model.trim="formData.title" maxlength="60"
                                show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="buttonContent" label="按钮文案:"
                            :rules="[{ required: true, message: '请填写按钮文案' }]">
                            <el-input placeholder="请填写按钮文案" v-model.trim="formData.buttonContent" maxlength="10"
                                show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="30">
                    <el-col :xs="24" :xl="16">
                        <el-form-item prop="content" label="弹窗内容:" :rules="[{ required: true, message: '请填写弹窗内容' }]">
                            <tinymce v-model="formData.content" :height="300" :toolbar="toolbar" :menubar="false" v-if="reFresh"></tinymce>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>
            <el-row v-else :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="imgPath" label="图片:" :rules="[{ required: true, message: '请上传图片' }]">
                        <image-upload :url.sync="formData.imgPath" :urlFull.sync="formData.imgPath"
                            accept="image/png, image/jpeg, image/jpg, image/gif, image/svga" crop :width="560"
                            :height="772"></image-upload>
                    </el-form-item>
                </el-col>
            </el-row>
        </template>
    </div>
</template>
<script>
import ImageUpload from '@/components/ImageUpload';
import Tinymce from '@/components/Tinymce';
export default {
    components: { ImageUpload, Tinymce },
    props: {
        formData: {
            type: Object,
            default: null
        },
        validateBindIds: {
            type: Function,
            default: () => { }
        },
        reFresh: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            toolbar:['fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify '],
        }
    },
    methods: {
        adTypeChange() {
            this.formData.content = "";
            this.$emit('clearValidate');
        }
    }
}
</script>